var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.027,
    x2: 1,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5fa2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_522",
    "data-name": "Union 522",
    d: "M11.111,15.556A4.444,4.444,0,1,1,15.556,20,4.458,4.458,0,0,1,11.111,15.556Zm4-2.223v2.223a.42.42,0,0,0,.445.444h1.333a.445.445,0,0,0,0-.889H16V13.333a.445.445,0,0,0-.889,0ZM11.2,20H5.136a5.224,5.224,0,0,1-3.729-1.33A5.085,5.085,0,0,1,0,14.9V8.283H18.139V9.9a6.147,6.147,0,0,0-2.583-.562A6.256,6.256,0,0,0,9.47,14.252a.69.69,0,0,0-.388-.118H9.074a.7.7,0,0,0,0,1.4h.008a.69.69,0,0,0,.251-.047v.073A6.173,6.173,0,0,0,11.2,20l0,0ZM4.24,14.832a.7.7,0,0,0,.7.7h.008a.7.7,0,1,0,0-1.4H4.938A.7.7,0,0,0,4.24,14.832Zm4.136-3.613a.7.7,0,0,0,.7.7h.008a.7.7,0,1,0,0-1.395H9.074A.7.7,0,0,0,8.376,11.219Zm-4.136,0a.7.7,0,0,0,.7.7h.008a.7.7,0,1,0,0-1.395H4.938A.7.7,0,0,0,4.24,11.219Zm13.9-4.331H0v-.4A4.963,4.963,0,0,1,1.412,2.771,5.07,5.07,0,0,1,4.62,1.486V.7a.7.7,0,0,1,1.4,0v.77h6.119V.7a.7.7,0,1,1,1.4,0v.788a5.017,5.017,0,0,1,3.283,1.359,4.989,4.989,0,0,1,1.325,3.642v.4h0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarActive);
export default __webpack_public_path__ + "static/media/icon-calendar-active.f938dee6df8e1563ed046d9514c0bd00.svg";
export { ForwardRef as ReactComponent };